let GoogleMap = require('./components');

module.exports = {
  install (Vue, {apiKey, options, config}) {
    if (!apiKey) {
      console.error('No API Key provided to Google Maps component');
    }

    Vue.component(GoogleMap.componentName, GoogleMap);
    Vue.prototype.$gmaps = require('google-maps-api')(apiKey, ['places']);
    Vue.prototype.$gmapsDefaults = config || {};
    Vue.prototype.$gmapsOptions = options || {};
  }
};
